
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('p')]),_c('g',[_c('path',{staticClass:"cls-1",attrs:{"d":"M604.88,378.51,406.26,180a8.83,8.83,0,0,0-12.46,0L195.13,378.51a8.77,8.77,0,0,0,6.21,15H239.8V582.62a10,10,0,0,0,10,10h88.34a10,10,0,0,0,10-10v-101a10,10,0,0,1,10-10h83.73a10,10,0,0,1,10,10v101a10,10,0,0,0,10,10h88.39a10,10,0,0,0,10-10V393.5h38.41A8.78,8.78,0,0,0,604.88,378.51Z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M400,0C179.09,0,0,179.09,0,400S179.09,800,400,800,800,620.91,800,400,620.91,0,400,0ZM598.67,393.5H560.26V582.62a10,10,0,0,1-10,10H461.87a10,10,0,0,1-10-10v-101a10,10,0,0,0-10-10H358.14a10,10,0,0,0-10,10v101a10,10,0,0,1-10,10H249.8a10,10,0,0,1-10-10V393.5H201.34a8.77,8.77,0,0,1-6.21-15L393.8,180a8.83,8.83,0,0,1,12.46,0L604.88,378.51A8.78,8.78,0,0,1,598.67,393.5Z"}})])])
          )
        }
      }
    